import Vue from 'vue';

Vue.filter('capitalize', (val) => {
	return val[0].toUpperCase() + val.slice(1)
});
